import { render, staticRenderFns } from "./CancellationForm.vue?vue&type=template&id=2cacc577"
import script from "./CancellationForm.vue?vue&type=script&lang=js"
export * from "./CancellationForm.vue?vue&type=script&lang=js"
import style0 from "./CancellationForm.vue?vue&type=style&index=0&id=2cacc577&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports